import {
  EmailOutlined,
  LocationOnOutlined,
  PhoneInTalkOutlined,
} from "@mui/icons-material";

// Label/value copy lives in the i18n resources (contactInfo.*); the icons and
// the i18n key pair for each row stay here and are matched by position.
export const contactInfoRows = [
  {
    labelKey: "contactInfo.locationLabel",
    valueKey: "contactInfo.locationValue",
    icon: (
      <LocationOnOutlined
        color="primary"
        sx={{
          fontSize: { md: 40, xs: 36 },
        }}
      />
    ),
  },
  {
    labelKey: "contactInfo.callLabel",
    valueKey: "contactInfo.callValue",
    icon: (
      <PhoneInTalkOutlined
        color="primary"
        sx={{
          fontSize: { md: 40, xs: 36 },
        }}
      />
    ),
  },
  {
    labelKey: "contactInfo.mailLabel",
    valueKey: "contactInfo.mailValue",
    icon: (
      <EmailOutlined
        color="primary"
        sx={{
          fontSize: { md: 40, xs: 36 },
        }}
      />
    ),
  },
];
